import { PrimaryBorrowerEmail } from '../cards/email';
import LoanType from '../cards/loan-type';
import QualifyStart from '../cards/qualify-start';
import { Card, End } from '../components/deck';
import Coborrower from './branches/coborrower';
import { creditAuthorizationBranch } from './branches/credit-authorization';
import Disqualifying from './branches/disqualifying';
import Employment from './branches/employment';
import { RefiLiensBranch } from './branches/refi-liens';
import Refinance from './branches/refinance';
import { VeteranStatusCompleted } from './branches/veteran-status-completed';

export default Card(
  QualifyStart,
  Refinance(
    VeteranStatusCompleted(
      Card(
        LoanType,
        RefiLiensBranch(
          Employment(
            'borrower',
            Coborrower(
              Disqualifying(creditAuthorizationBranch(Card(PrimaryBorrowerEmail(true), End())))
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/refi-qualify.js